<template>
  <div data-testid="audit-log-per-day">
    <div
      v-for="(itemsForDay, date) in itemsPerDay"
      :key="date"
      class="tw-flex tw-flex-col tw-gap-2"
      :data-testid="`audit-log-per-day-wrapper-${date}`"
    >
      <div class="sf-font-l sf-title tw-px-6 tw-pt-4">
        {{ date }}
      </div>
      <audit-log :items="itemsForDay"></audit-log>
    </div>
  </div>
</template>

<script>
import groupAuditsPerDay from '../ledger-audit-log/utils/group-audits-per-day'
import AuditLog from './audit-log'

export default {
  components: {
    AuditLog,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    itemsPerDay() {
      const timestampGetter = (item) => item.sortTimestamp * 1000

      const _items = [...this.items]
      const index = _items.findIndex(
        (e) => e.kind === 'changes-since-last-visit-line'
      )

      // changes since last visit should not be collapsed
      for (let i = 0; i < index; i++) {
        _items[i].collapsedState = false
      }

      return groupAuditsPerDay({ audits: _items, timestampGetter })
    },
    days() {
      return Object.keys(this.itemsPerDay)
    },
  },
}
</script>
